import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Card, CardBody } from 'reactstrap';
import { getLabels, getTotalValuesByLegends, getValues } from '../../../utils/chart-utils';
import { NAV_BAR_WIDTH } from '../../../const/settings';
import { SALES_PER_PRODUCT_AND_EMPLOYEE } from '../../pages/reports/standard/StandardReportConfig';
import Chart from './Chart';

const useStyles = makeStyles(theme => ({
  chartsWrapper: {
    width: `100%`,
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(1.5, 0, 1.5, 0),
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(1.5),
      maxWidth: `calc(100vw - ${NAV_BAR_WIDTH}px)`,
    },
  },
}));

const ChartsWrapper = (props) => {
  const { charts, reports, languageState, reportName } = props;
  const styles = useStyles();
  
  if (!charts || !reports || reportName === SALES_PER_PRODUCT_AND_EMPLOYEE.reportName) {
    return null;
  }
  
  const nonZeroCharts = charts.map(chart => ({
    ...chart,
    values: getValues(chart.valueFields, reports),
    labels: getLabels(chart.labelFields, reports, languageState),
  })).filter(chart =>
    !chart.values.every(valueList => valueList.every(value => !value)),
  );
  
  function getChartDataWithoutTotal(chart) {
    const totalLabelCount = chart.labels.flat().filter(el => el === 'Totalt').length;
    if (totalLabelCount === 1) {
      const modifiedValues = chart.values.map(valueArray => valueArray.slice(0, -1));
      const modifiedLabels = chart.labels.filter(subarray => !subarray.includes('Totalt'));
      return {
        ...chart,
        labels: modifiedLabels,
        values: modifiedValues,
      };
    }
    return chart;
  }
  
  return (
    <div className={styles.chartsWrapper}>
      {nonZeroCharts.map((chart) => (
        <Card key={chart.id} className="card-chart">
          <CardBody>
            <Chart
              chartData={getChartDataWithoutTotal(chart)}
              totalValues={getTotalValuesByLegends(chart.legends, chart)}
            />
          </CardBody>
        </Card>
      ))}
    </div>
  );
};

ChartsWrapper.propTypes = {
  charts: PropTypes.array,
  reports: PropTypes.array,
  languageState: PropTypes.string,
  reportName: PropTypes.string,
};

export default ChartsWrapper;
